// src/pages/DayTourDetail.jsx
import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { dayTours } from "../data/tours";
import "./DayTours.css";

export default function DayTourDetail() {
  const { id } = useParams();
  const tour = dayTours.find((t) => t.id === id);

  // Hooks at top-level
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    people: "",
  });

  if (!tour) return <p>Tour not found</p>;

  // === Handlers ===
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBook = (e) => {
    e.preventDefault();
    const message = encodeURIComponent(
      `Hello, I want to book: ${tour.title}\n` +
      `Name: ${form.name}\n` +
      `Email: ${form.email}\n` +
      `Number of people: ${form.people}`
    );
    const whatsappLink = `https://wa.me/255718665620?text=${message}`;
    window.open(whatsappLink, "_blank");
  };

  return (
    <section className="tour-detail-card">
      <div className="detail-layout">
        {/* Image */}
        <div className="detail-image-wrapper">
          <img
            src={tour.image.startsWith("/") ? tour.image : `/images/${tour.image}`}
            alt={tour.title}
            className="detail-image"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/images/placeholder.png";
            }}
          />
        </div>

        {/* Text */}
        <div className="detail-text">
          <h2>{tour.title}</h2>
          <p className="location">📍 {tour.location}</p>
          <p>{tour.longDescription}</p>

          {/* Booking Form Modal */}
          {showForm && (
            <div
              className="modal-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
              onClick={() => setShowForm(false)}
            >
              <div
                className="modal-content"
                style={{
                  backgroundColor: "#fff",
                  padding: 20,
                  borderRadius: 8,
                  minWidth: 300,
                  maxWidth: 400,
                  position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3>Book This Tour</h3>
                <form
                  onSubmit={handleBook}
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    style={{ padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email (optional)"
                    value={form.email}
                    onChange={handleChange}
                    style={{ padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                  />
                  <input
  type="number"
  name="people"
  placeholder="Number of people"
  min="1"
  value={form.people}
  onChange={handleChange}
  required
  style={{
    padding: 8,
    borderRadius: 4,
    border: "1px solid #ccc",
  }}
/>
                  <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                    <button
                      type="submit"
                      style={{
                        flex: 1,
                        padding: "10px",
                        backgroundColor: "#25D366",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Book via WhatsApp
                    </button>
                    <button
                      type="button"
                      onClick={() => setShowForm(false)}
                      style={{
                        flex: 1,
                        padding: "10px",
                        backgroundColor: "#ccc",
                        color: "#000",
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Book Tour Button */}
          <div style={{ marginTop: 20 }}>
            <button
              onClick={() => setShowForm(true)}
              style={{
                padding: "10px 20px",
                backgroundColor: "#25D366",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Book Tour
            </button>
          </div>

          <Link to="/day-tours" className="btn-back" style={{ marginTop: 20 }}>
            ← Back to Tours
          </Link>
        </div>
      </div>
    </section>
  );
}
